// ═══════════════════════════════════════════════════════════════════
//  socle/format.js
//  Formatage des nombres, des montants, des tailles et des dates relatives.
// ═══════════════════════════════════════════════════════════════════

// ── Helpers ─────────────────────────────────────────────────────────────
export function fmtEur(n){ return (Number(n)||0).toLocaleString("fr-FR",{style:"currency",currency:"EUR"}); }

export function fmtGems(n){ return Math.round(Number(n)||0).toLocaleString("fr-FR"); }

export function fmtSize(b){ b=Number(b)||0; if(b<1024) return b+" o"; if(b<1048576) return (b/1024).toFixed(0)+" Ko"; return (b/1048576).toFixed(1)+" Mo"; }

export const fmt = (n) => (n == null ? "—" : Number(n).toLocaleString("fr-FR"));

export function timeAgo(ts) {
  if (!ts) return "";
  const d = Math.floor((Date.now() - new Date(ts).getTime()) / 1000);
  if (d < 60) return "à l'instant";
  if (d < 3600) return `il y a ${Math.floor(d / 60)} min`;
  if (d < 86400) return `il y a ${Math.floor(d / 3600)} h`;
  return `il y a ${Math.floor(d / 86400)} j`;
}
